export const headCells = [
    {id: 'id', label: 'LP'},
    {id: 'description', label: 'Opis'},
    {id: 'content', label: 'Treść'},
    {id: 'file', label: 'Plik'},
    {id: 'actions', label: 'Działania'},
];